/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($, Tc, SCS) {
	'use strict';
	var sdxModal = require('lib/generic/SDXModalDialog').default;
	var deparam = require('lib/vendor/jquery-deparam-patched').default;
	var replacePlaceholders = require('lib/ecommerce/Tc.Module.PriceBox').replacePlaceholders;

	var SIMPLE_PAY_URL_KEY = 'simplepay';
	var SIMPLE_PAY_DURATION_URL_INITIAL_VALUE = 24;
	var WARRANTY_URL_INITIAL_VALUE = 'true';

	/**
	 * Initialize Order Overlay from Price & Orderlink
	 *
	 * Subscribes to channels: [EcommerceProductDataHub, serviceavailabilitycheck]
	 * Listens to channel events: [startProductDataSubscription, invalidateProductData, dialogClosed]
	 * Triggers channel events: [subscribeForProductData, getInfo, OpenOverlay, updateStatus]
	 *
	 * @author Marc Althoff, Renaldas Szentiks, Matthias Inauen
	 * @namespace Tc.Module
	 * @class OrderOverlay
	 * @extends Tc.Module
	 */
	Tc.Module.PriceOrderContainer = Tc.Module.extend({

		/**
		 * List of available placeholders in the component
		 */
		PLACEHOLDERS: {
			productId: 'productId',
			minimumPrice: 'minimumPrice',
			originalPrice: 'originalPrice',
			currentPrice: 'currentPrice',
			subscriptionPrice: 'subscriptionPrice',
			subscriptionId: 'subscriptionId',
			subscriptionDuration: 'subscriptionDuration',
			subscriptionType: 'subscriptionType',
			detailPagePath: 'detailPagePath',
			quantity: 'quantity',
			subscriptionName: 'subscriptionName',
			familyName: 'familyName',
			familyId: 'familyId',
			simplePayMonthlyPrice: 'simplePayMonthlyPrice',
			simplePayInitialPrice: 'simplePayInitialPrice',
			simplePayChecked: 'simplePayChecked',
			simplePayDuration: 'simplePayDuration',
			warrantyChecked: 'warranty',
			priceInstead: 'priceInstead',
			xtraDiscount: 'xtraDiscount'
		},

		CHECKOUT_URL_TYPES: {
			automatic: 'automatic',
			configurableProduct: 'configurableProduct',
			accessory: 'accessory',
			eorders: 'eorders',
			manual: 'manual',
			notify: 'notify'
		},

		// How long to wait for tracking call to complete before ordering
		TRACKING_TIMEOUT: 5000,
		/**
		 * Selectors of placeholder aware elements which can contain placeholders
		 */
		PLACEHOLDER_AWARE_ELEMENTS: [
			'.price',
			'.secondary-button',
			'.details-link',
			'.price-subtitle',
			'.footnote',
			'.tracking',
			'.price-instead',
			'.orderButton',
			'.xtraDiscount'
		],

		/**
		 * Attributes of placeholder aware elements, which can contain placeholders
		 */
		PLACEHOLDER_AWARE_ATTRIBUTES: [
			'href',
			'data-tracking-friendlyname',
			'data-tracking-location',
			'data-tracking-action',
			'data-tracking-label',
			'data-tracking-category',
			'data-tracking-conversioncategory',
			'data-tracking-conversiondetail',
			'data-tracking-conversionclass',
			'data-rebate-price',
			'data-xtra-price'
		],

		// The setTimeout handle that waits for tracking to complete (see TRACKING_TIMEOUT)
		trackingTimeout: null,

		on: function (callback) {
			var mod = this,
				placeholder = {};

			mod.actionLink = mod.$ctx.find('.action-link');
			// Remember the link label (if not responding to availabilityStatus)
			mod.actionLink.data('default-label', mod.actionLink.text());
			mod.detailsLink = mod.$ctx.find('.details-link');
			mod.hasOverlay = mod.$ctx.data('order-link') ? true : false;
			mod.useDynamicPrice = mod.$ctx.data('use-dynamic-price');
			mod.subscriptionId = mod.$ctx.data('subscription-id');
			mod.showSubscriptionDuration = mod.$ctx.data('show-subscription-duration');
			mod.msgExtendSubscription = mod.$ctx.data('msg-extend-subscription');

			mod.productId = mod.$ctx.data('product-id');
			mod.familyId = mod.$ctx.data('family-id');

			mod.useAutomaticProductId = this.$ctx.data('checkout-url-type') === this.CHECKOUT_URL_TYPES.automatic || mod.productId === '${productId}';
			mod.useAutomaticFamilyId = this.$ctx.data('checkout-url-type') === this.CHECKOUT_URL_TYPES.automatic || mod.productId === '${familyId}';

			mod.linkParams = mod.$ctx.data('order-link-params');
			mod.isMobilePage = $('body').hasClass('is-mobile');
			mod.hasSimplePay = mod.$ctx.data('simple-pay-active');
			mod.hasWarranty = mod.$ctx.data('warranty-show-checkbox');
			mod.aboDiscountOverrides = mod.$ctx.data('abo-discount-overrides') || {};

			if (mod.hasSimplePay) {
				mod.simplePayCheckbox = mod.$ctx.find('input[name=simplepay]');
				mod.title1 = mod.$ctx.find('.title');
				mod.title2 = mod.$ctx.find('.title2');
				mod.priceSecond = mod.$ctx.find('.price-second');
				mod.simplePayPrices = mod.$ctx.find('.simple-pay-prices');
				mod.priceFirst = mod.$ctx.find('.price-first');
				mod.simplePayInitialPrice = mod.$ctx.find('.simple-pay-initial-price');
				// In simplified simple price mode, the second price is assumed to be configured
				// to display all relevant simple pay information.
				// No custom layout/styling is applied.
				mod.simplifiedSimplePrice = mod.priceSecond.find('span.price').text() === '${simplePayMonthlyPrice}';

				// set simple pay to disabled initially and wait for the ecommerce data hub
				// to enable/disable it based on the data of the product
				mod.handleSimplePay();
			}

			if (mod.hasWarranty) {
				mod.warrantyCheckbox = mod.$ctx.find('input[name=warranty]');
				mod.warrantyCheckbox.on('change', mod.handleWarranty.bind(mod));
				mod.warrantyCheckbox.trigger('change');
			}

			if ((typeof (mod.$ctx.data('checkout-url-type')) === 'undefined' || !mod.$ctx.data('checkout-url-type').length)) {
				mod.$ctx.data('checkout-url-type', mod.CHECKOUT_URL_TYPES.automatic);
			}

			mod.CHECKOUT_URL_TYPE = mod.$ctx.data('checkout-url-type');
			mod.BUY_BUTTON_LABEL = mod.actionLink.text();

			mod.actionLink.on('click', $.proxy(mod.handleActionLinkClick, mod));
			mod.$ctx.on('ctaClick', function () {
				if (!mod.actionLinkDisabled) {
					if (mod.actionLink.length) {
						mod.ctaClickTriggered = true;
						mod.actionLink.trigger('click');
					} else if (mod.detailsLink.length) {
						mod.detailsLink[0].click();
					}
				}
			});
			mod.$ctx.on('detailsClick', function () {
				if (mod.detailsLink.length) {
					mod.detailsLink[0].click();
				}
			});
			if (mod.showSubscriptionDuration) {
				mod.initDurations();
			}
			mod.prepareVariantOrderLinks();
			mod.updateCTAUrl(mod.getCheckoutUrlType());
			placeholder[mod.PLACEHOLDERS.productId] = mod.productId;
			placeholder[mod.PLACEHOLDERS.familyId] = mod.familyId;
			mod.updatePlaceholders(placeholder);

			if (mod.useDynamicPrice) {
				mod.updatePlaceholders({}, true);
				mod.onStartProductDataSubscription();
			}

			mod.$ctx.closest('.modVisibilityControlContainer').on('visibilityControl-show', function (event) {
				// jshint unused: false
				mod.onShow();
			});

			mod.$ctx.closest('.modVisibilityControlContainer').on('visibilityControl-hide', function (event) {
				// jshint unused: false
				mod.onHide();
			});

			if (!$.cookie('SCSMiniShoppingCart')) {
				$.cookie('SCSMiniShoppingCart', '', { path: '/' });
			}

			callback();
		},

		after: function () {
			var mod = this;

			if (SCS.utils.isMobilePage()) {
				mod.fire('AdjustGalleryHeight', {});
			}

			if (mod.useDynamicPrice) {
				mod.onInvalidateProductData({});
			}
		},

		/**
		 * Channel listener to register for EcommerceProductDataHub events.
		 *
		 * @method onStartProductDataSubscription
		 * @return void
		 */
		onStartProductDataSubscription: function () {
			var mod = this,
				initialChannel = 'EcommerceProductDataHub';
			mod.sandbox.subscribe(initialChannel, mod);
			mod.fire('subscribeForProductData', {
				element: mod.$ctx,
				subscribe: function (channel, fetchDataOnSubscribe) {
					if (mod.productDataChannel) {
						mod.sandbox.unsubscribe(mod.productDataChannel, mod);
					}
					mod.productDataChannel = channel;
					mod.sandbox.unsubscribe(initialChannel, mod);
					mod.sandbox.subscribe(channel, mod);
					mod.$ctx.removeClass('initializing');

					// If component was lazy loaded, request initialization data
					// from data hub.
					if (fetchDataOnSubscribe) {
						mod.fire('getInfo', {
							callback: function (data) {
								mod.onInvalidateProductData({ info: data });
							}
						}, [mod.productDataChannel]);
					}
				}
			}, [initialChannel]);
		},

		/**
		 * Channel listener which gets called by EcommerceProductDataHub to notify about data changes.
		 *
		 * @method onInvalidateProductData
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		onInvalidateProductData: function (data) {
			// jshint unused: false
			var mod = this, status = {};
			if (mod.productDataChannel) {
				if (mod.subscriptionId) {
					status.subscriptionId = mod.subscriptionId;
				}
				// request the new data based on the settings in this component
				mod.fire('getInfo', {
					status: status,
					callback: $.proxy(mod.getInfoCallback, mod)
				}, [mod.productDataChannel]);
			}
		},

		/**
		 * Callback function which gets passed as a parameter to the [GetInfo] channel event.
		 *
		 * Creates all required placeholders and initiates the placeholder replacement in the component.
		 *
		 * @method getInfoCallback
		 * @param {Object} data See EcommerceProductDataHub for details about the structure
		 * @return void
		 */
		getInfoCallback: function (data) {
			var mod = this,
				placeholders = {},
				zeroDotEmDash = '0.—',
				emDash = '—',
				isSimplePayAllowed = false,
				simplePayMonthlyPrice;

			mod.actionLink.data('placeholder-template', mod.BUY_BUTTON_LABEL);

			// Set product family related placeholders
			if (data.family) {
				mod.updateFamilyId(data.family.getId());
				placeholders[mod.PLACEHOLDERS.detailPagePath] = data.family.getDetailPagePath();
				placeholders[mod.PLACEHOLDERS.familyName] = data.family.getFamilyName();
				placeholders[mod.PLACEHOLDERS.familyId] = (mod.CHECKOUT_URL_TYPE !== mod.CHECKOUT_URL_TYPES.automatic) ? mod.familyId : data.family.getId();
				// Turn simple pay on or off for the whole family
				if (mod.hasSimplePay) {
					if (data.family.isSimplePayAllowed() === true) {
						isSimplePayAllowed = true;
						mod.simplePayCheckbox.closest('.field').removeClass('hidden');
					}
					else {
						// un-check the checkbox before hiding
						mod.simplePayCheckbox.prop('checked', false).trigger('change').closest('.field').addClass('hidden');
					}
				}
			}
			// Set product variant related placeholders
			var makePrice = require('lib/ecommerce/Price').default;
			if (data.product) {
				var id = data.product.getId();
				mod.updateProductId(id);
				mod.checkPromotions(data);
				placeholders[mod.PLACEHOLDERS.productId] = (mod.CHECKOUT_URL_TYPE !== mod.CHECKOUT_URL_TYPES.automatic) ? mod.productId : data.product.getId();
				placeholders[mod.PLACEHOLDERS.minimumPrice] = data.product.getMinimumPrice().formatted();
				placeholders[mod.PLACEHOLDERS.originalPrice] = data.product.getOriginalPrice().formatted();

				if (data.subscriptionType === 'without' && !data.subscriptionId) {
					placeholders[mod.PLACEHOLDERS.currentPrice] = data.product.getDiscountedPrice().formatted(); // device only, sale price
					if (data.product.isDiscounted()) {
						placeholders[mod.PLACEHOLDERS.priceInstead] = data.product.getOriginalPrice().formatted();
					} else {
						placeholders[mod.PLACEHOLDERS.priceInstead] = '';
					}
					placeholders[mod.PLACEHOLDERS.subscriptionPrice] = zeroDotEmDash;
				}
				else {
					var subscriptions = data.product.getSubscriptions();
					placeholders[mod.PLACEHOLDERS.currentPrice] = data.product.getPrice(data.subscriptionId, data.subscriptionDuration).formatted();
					var recurringCharge = subscriptions.getRecurringCharge(data.subscriptionId, data.subscriptionDuration) || makePrice();
					placeholders[mod.PLACEHOLDERS.subscriptionPrice] = recurringCharge.formatted();

					if (data.subscriptionId in mod.aboDiscountOverrides) {
						var discount = mod.aboDiscountOverrides[data.subscriptionId];
						var charge = subscriptions.getRecurringCharge(data.subscriptionId, data.subscriptionDuration) - discount;
						placeholders[mod.PLACEHOLDERS.subscriptionPrice] = makePrice(charge).formatted();
						placeholders[mod.PLACEHOLDERS.xtraDiscount] = makePrice(discount).formatted();
					}
					else {
						placeholders[mod.PLACEHOLDERS.xtraDiscount] = '';
					}

					var subscriptionPricing = data.product.getSubscriptionPrice(data.subscriptionId, data.subscriptionDuration);
					if (!subscriptionPricing && data.product.isDiscounted()) {
						// placeholders[mod.PLACEHOLDERS.currentPrice] will already contain the discounted price since that’s what
						// getPrice() does if no subscription matches (and this holds because getSubscriptionPrice returned null)
						placeholders[mod.PLACEHOLDERS.priceInstead] = data.product.getOriginalPrice().formatted();
					}
					else {
						placeholders[mod.PLACEHOLDERS.priceInstead] = '';
					}
				}

				placeholders[mod.PLACEHOLDERS.subscriptionName] = data.product.getSubscriptions().getName(data.subscriptionId);

				var availability = data.product.getAvailability();
				availability.load().always(function () {
					if (id !== mod.currentProductId) {
						// User has changed the product since the availability info started loading
						return;
					}

					// FIXME NEC: Refactor: getCheckoutUrlType relies on availability to be loaded but does not declare so
					mod.updateCTAUrl(mod.getCheckoutUrlType(data.product), data);

					if (!mod.actionLink.attr('href')) {
						// No link ⇒ no need for availability info to load…
						mod.updateActionLinkStatus(false);
					} else {
						mod.updateActionLinkStatus(availability.isActionable(), availability.getStatus());
					}

					mod.updatePlaceholders(placeholders);
				});

				if (isSimplePayAllowed) {
					simplePayMonthlyPrice = data.product.getSimplePayMonthlyPrice(data.subscriptionId, data.subscriptionDuration);
					placeholders[mod.PLACEHOLDERS.simplePayMonthlyPrice] = simplePayMonthlyPrice;
					placeholders[mod.PLACEHOLDERS.simplePayInitialPrice] = data.product.getSimplePayInitialPrice(data.subscriptionId, data.subscriptionDuration);

					if (parseFloat(simplePayMonthlyPrice) > 0) {
						mod.enableSimplePay();
					}
					else {
						mod.disableSimplePay();
					}

					// if the simplepay option was checked before, add it back to the call to action url.
					if (!this.simplePayCheckbox.prop('readonly') && this.simplePayChecked) {
						this.addUrlParam(SIMPLE_PAY_URL_KEY, true);
					}
				}

				if (mod.hasWarranty && !data.product.hasGuaranteeExtension()) {
					mod.warrantyCheckbox.closest('.field').addClass('hidden');
				} else if (mod.hasWarranty) {
					mod.warrantyCheckbox.prop('checked', WARRANTY_URL_INITIAL_VALUE).trigger('change');
					mod.updateWarrantyLabel(mod.warrantyCheckbox, data.product);
					mod.warrantyCheckbox.closest('.field').removeClass('hidden');
				}
			}
			else {
				mod.updateActionLinkStatus(false);
				mod.updateProductId('');
				placeholders[mod.PLACEHOLDERS.minimumPrice] = emDash;
				placeholders[mod.PLACEHOLDERS.originalPrice] = emDash;
				placeholders[mod.PLACEHOLDERS.currentPrice] = emDash;
				placeholders[mod.PLACEHOLDERS.subscriptionPrice] = emDash;
				// disable simple pay - there's no product
				if (isSimplePayAllowed) {
					mod.disableSimplePay();
				}
			}

			if (data.subscriptionId === 'retention') {
				placeholders[mod.PLACEHOLDERS.subscriptionPrice] = emDash;
			}
			else if (data.subscriptionId === 'without') {
				placeholders[mod.PLACEHOLDERS.subscriptionPrice] = emDash;
			}
			else {
				placeholders[mod.PLACEHOLDERS.subscriptionId] = data.subscriptionId;
				placeholders[mod.PLACEHOLDERS.subscriptionDuration] = data.subscriptionDuration;
			}

			if (data.subscriptionType === 'retention') {
				mod.showMessage(mod.msgExtendSubscription);
			}
			else {
				mod.showMessage(null);
			}

			placeholders[mod.PLACEHOLDERS.subscriptionType] = data.subscriptionType;
			placeholders[mod.PLACEHOLDERS.quantity] = data.quantity;
			mod.quantity = (typeof (data.quantity) === 'undefined') ? 1 : data.quantity;

			if (mod.showSubscriptionDuration) {
				mod.setDuration(data.subscriptionDuration);
			}
			mod.updatePlaceholders(placeholders);
		},

		enableSimplePay: function () {
			this.simplePayCheckbox.prop('readonly', false).closest('.custom-checkbox').attr('readonly', false);
			this.simplePayCheckbox.on('change.PriceOrderContainer', this.handleSimplePay.bind(this));
		},

		disableSimplePay: function () {
			this.simplePayCheckbox.prop('checked', false).prop('readonly', true).closest('.custom-checkbox').attr('readonly', true);
			this.handleSimplePay();
			this.simplePayCheckbox.off('change.PriceOrderContainer');
		},

		showMessage: function (text) {
			var mod = this;
			if (!mod.priceContainer) {
				mod.priceContainer = $('.pricetag .price-first, .pricetag .price-second', mod.$ctx);
			}
			if (!mod.simplePayChecked) {
				if (!mod.messageContainer) {
					mod.messageContainer = $('<div>').addClass('message-container').addClass('hidden');
					mod.messageContainer = $('<div>').addClass('message-container').addClass('hidden');
					mod.messageContainer.html('&nbsp;').prepend($('<div>').addClass('text'));
					$('.pricetag', mod.$ctx).prepend(mod.messageContainer);
				}
				if (text) {
					mod.messageContainer.removeClass('hidden').find('.text').text(text);
					mod.priceContainer.addClass('hidden');
				} else {
					mod.priceContainer.removeClass('hidden');
					mod.messageContainer.addClass('hidden').find('.text').text('');
				}
			}
		},

		/**
		 * Check if promotions are available and display text.
		 *
		 * @method checkPromotions
		 * @param {object} data returned from ecommerce product data hub
		 * @return void
		 */
		checkPromotions: function (data) {
			var mod = this,
				$promotionWrapper = mod.$ctx.find('.product-promotion');

			// Do a little bit of magic to check whether there is already a ProductDetail component configured to display promotions
			var $container = this.$ctx.closest('.modEcommerceProductDataHub, .modTabNavigationSharedContent, .modLayoutcontainer.actionboxProducts');
			var $productDetailPromoDisplay = $container.find('.modEcommerceProductDetail[data-type="promotionName"]');

			if (!data.subscriptionId || $promotionWrapper.hasClass('hidden') || $productDetailPromoDisplay.length) {
				$promotionWrapper.hide();
				return;
			}

			var promotions = data.product.getApplicablePromotions(
				data.subscriptionId,
				data.subscriptionDuration,
				data.subscriptionType
			).filter(function (promotion) {
				return !promotion.isCallout();
			}).map(function (promotion) {
				// Create an element for each promo
				return $('<div/>', { text: promotion.getName() });
			});

			if (!promotions.length) {
				$promotionWrapper.hide();
				return;
			}

			$promotionWrapper.html(promotions).show();
		},

		/**
		 * Updates the status of the action link.
		 *
		 * @method updateActionLinkStatus
		 * @param {Boolean} isEnabled Status of the action link
		 * @return void
		 */
		updateActionLinkStatus: function (isEnabled, productAvailability) {
			var mod = this;

			if (isEnabled || mod.variantOrderLink) {
				mod.actionLinkDisabled = false;
				mod.actionLink.removeClass('disabled');
			} else {
				mod.actionLinkDisabled = true;
				mod.actionLink.addClass('disabled');
			}

			var label = mod.actionLink.data('default-label');
			if (productAvailability) {
				label = mod.$ctx.data(productAvailability.toLowerCase());
				//Replace the value inside the place-holder template as well. Otherwise it gets reverted after changing.
				mod.actionLink.data('placeholder-template', label);
				mod.actionLink.text(label);
			}
		},

		/**
		 * Updates the call to action url based on the product type.
		 *
		 * @param checkoutUrlType
		 * @param data
		 */
		updateCTAUrl: function (checkoutUrlType, data) {
			var url = '';

			if (this.productId && this.productId in this.variantOrderLinks) {
				// Use variant order link and ignore type
				url = this.variantOrderLinks[this.productId];
				this.variantOrderLink = true;
			} else {
				// Use default behaviour
				switch (checkoutUrlType) {
					case this.CHECKOUT_URL_TYPES.accessory:
						url = this.$ctx.data('url-addtobasket');
						break;
					case this.CHECKOUT_URL_TYPES.configurableProduct:
						if (data.product.isAddProductAndShowBasket(data.subscriptionType)) {
							url = this.getAddProductAndShowBasketUrl();
						} else {
							url = this.$ctx.data('url-productconfig');
						}
						break;
					case this.CHECKOUT_URL_TYPES.eorders:
						url = this.$ctx.data('url-maporder');
						break;
					case this.CHECKOUT_URL_TYPES.manual:
						url = this.$ctx.data('url-manual');
						break;
					case this.CHECKOUT_URL_TYPES.notify:
						if (data && data.product && data.product.getNotifyUrl()) {
							url = data.product.getNotifyUrl();
						}
						break;
					default:
						url = this.$ctx.data('url-maporder');
				}

				url = this.appendUrlParameters(url, data);
			}
			this.actionLink.data('placeholder-template-href', url);
			this.actionLink.attr('href', url);
		},

		/**
		 * Returns the checkout URL of a product where the eCommerce Configuration page can be skipped.
		 */
		getAddProductAndShowBasketUrl: function () {
			if (this.isMobilePage) {
				return '/portalshop/' + $('html').attr('lang') + '/' + $('body').data('page-segment') +
					'/Basket/AddWatch?deviceId=${productId}&simplePay=${simplePayChecked}&duration=${simplePayDuration}&warranty=${warrantyChecked}';
			} else {
				return '/content/swisscom/' + $('html').attr('lang') + '/' + $('body').data('page-segment') +
					'/addproduct#deviceId=${productId}&simplepay=${simplePayChecked}&duration=${simplePayDuration}&warranty=${warrantyChecked}';
			}
		},

		/**
		 * Appending parameters to the checkout url
		 *
		 * @param url
		 * @param data
		 * @returns url string
		 */
		appendUrlParameters: function (url, data) {
			var urlBase,
				urlParams,
				urlHash,
				tmpUrl,
				returnUrl = url;

			if (!url) {
				return returnUrl;
			}

			urlHash = url.split('#')[1];
			urlParams = url.split('#')[0].split('?')[1];
			urlBase = url.split('#')[0].split('?')[0];


			if (this.CHECKOUT_URL_TYPE === this.CHECKOUT_URL_TYPES.manual && this.linkParams) {
				if (this.linkParams.indexOf('?') > -1) {
					urlParams = (urlParams && urlParams.length) ? (urlParams + '&' + this.linkParams.substring(1)) : this.linkParams.substring(1);
				}
				else if (this.linkParams.indexOf('#') > -1) {
					urlHash = (urlHash && urlHash.length) ? (urlHash + '&' + this.linkParams.substring(1)) : this.linkParams.substring(1);
				}
				else {
					urlParams = (urlParams && urlParams.length) ? (urlParams + '&' + this.linkParams) : this.linkParams;
				}
			}

			if (this.ctaType === this.CHECKOUT_URL_TYPES.configurableProduct && data && data.product && data.product.canHaveSubscriptions()) {
				if (data.subscriptionId) {
					tmpUrl = 'aboId=' + encodeURIComponent(data.subscriptionId);
					if (data.subscriptionDuration) {
						tmpUrl = tmpUrl + '&duration=' + encodeURIComponent(data.subscriptionDuration);
					}
				}

				if (data.subscriptionType) {
					tmpUrl = (tmpUrl) ? (tmpUrl + '&subscriptioncasetype=' + encodeURIComponent(data.subscriptionType)) : 'subscriptioncasetype=' + encodeURIComponent(data.subscriptionType);
				}

				if (this.isMobilePage) {
					urlParams = (urlParams && urlParams.length) ? (urlParams + '&' + tmpUrl) : tmpUrl;
				} else {
					urlHash = (urlHash && urlHash.length) ? (urlHash + '&' + tmpUrl) : tmpUrl;
				}
			}

			returnUrl = urlBase;

			if (urlParams && urlParams.length) {
				returnUrl = returnUrl + '?' + urlParams;
			}
			if (urlHash && urlHash.length) {
				returnUrl = returnUrl + '#' + urlHash;
			}

			return returnUrl;
		},

		/**
		 * Adding the URL parameters to the actionlink url
		 * Manipulates the actionlink href attribute directly
		 * TODO: Why? Can’t this be done with a placeholder inside the URL?
		 */

		addUrlParam: function (paramName, paramValue) {
			var urlBase,
				urlBaseHash,
				returnUrl,
				newUrlString,
				urlParameters,
				url = this.actionLink.attr('href');

			if (url) {
				urlBaseHash = url.split('#')[0];
				urlBase = url.split('?')[0];

				urlParameters = this.mapQueryStringParameters(url);

				if (urlParameters[paramName]) {
					return;
				}

				urlParameters[paramName] = paramValue;
				newUrlString = $.param(urlParameters);

				returnUrl = this.isMobilePage ? urlBase + '?' + newUrlString : urlBaseHash + '#' + newUrlString;

				if (newUrlString !== undefined) {
					// FIXME: Test on non-watch device with simple pay.
					// Should the simple pay URL param be configured or do we need to fix it in code?

					// this.actionLink.data('placeholder-template-href', returnUrl);
					this.actionLink.attr('href', returnUrl);
				}
			}
		},

		/**
		 * Return URL query string object with parameters based on device
		 * @method mapQueryStringParameters
		 * @param {String} url
		 * @return {Object} parameters
		 */
		mapQueryStringParameters: function (url) {
			var urlParameters = {};

			if (this.isMobilePage) {
				var queryString = SCS.Url.parse(url).search.slice(1);

				if (queryString) {
					urlParameters = deparam(queryString);
				}
			} else {
				var fragmentString = SCS.Url.parse(url).hash.slice(1);

				if (fragmentString) {
					urlParameters = deparam(fragmentString);
				}
			}

			return urlParameters;
		},

		/**
		 * modifies the action link url directly and remove URL parameters
		 */

		removeUrlParam: function (paramName) {
			var urlBase,
				urlBaseHash,
				urlParameters = {},
				newUrlString,
				url = this.actionLink.attr('href');

			if (!url) {
				return;
			}

			urlBaseHash = url.split('#')[0];
			urlBase = url.split('?')[0];
			urlParameters = this.mapQueryStringParameters(url);

			if (urlParameters[paramName]) {
				delete urlParameters[paramName];
				newUrlString = $.param(urlParameters);
			}
		},

		/**
		 * Handler for the action link click event
		 * There are multiple cases to consider
		 * 1. The component specifies an overlay (e.g. Service Availability Overlay) -> open the overlay
		 * 2. Notify mode is enabled -> open the notification overlay
		 * 3. The product is an accessory and it's not a mobile page -> open the add accessory to basket overlay
		 * 4. In all other cases simply follow the href of the anchor.
		 *
		 * @method handleActionLinkClick
		 * @param {Object} event
		 * @return void
		 */
		handleActionLinkClick: function (event) {
			var mod = this,
				$button = $(event.currentTarget);

			$.cookie('SCSResumeShoppingLink', window.location.href, { 'path': '/' });

			if (!mod.overlayIsOpen && !mod.actionLinkDisabled) {

				mod.trackButtonClick();

				if (mod.hasOverlay) {
					mod.overlayIsOpen = true;
					if (!mod.$ctx.is('.cq_isEditMode *')) {
						mod.log('OpenOverlay',
							mod.$ctx.data('order-link'),
							mod.$ctx.data('order-link-no-login'),
							mod.$ctx.data('button-id'),
							mod.$ctx.data('product-id'),
							mod.$ctx.data('product-name')
						);
						mod.fire('OpenOverlay', {
							'orderLink': mod.$ctx.data('order-link'),
							'orderLinkNoLogin': mod.$ctx.data('order-link-no-login'),
							'orderButtonsId': mod.$ctx.data('button-id'),
							'productId': mod.$ctx.data('product-id'),
							'productName': mod.$ctx.data('product-name')
						});
					}
				}
				else if (mod.ctaType === mod.CHECKOUT_URL_TYPES.notify) {
					if (!SCS.utils.isMobilePage()) {
						var form = $('<form class="sdx-container"/>');
						form.data('title', mod.actionLink.text());
						mod.$ctx.append(form);
						form.load(mod.actionLink.attr('href'), function (response, status /* ,xhr */) {
							if (status !== 'error') {
								mod.initNotifyForm(form);
							}
						});
					} else {
						mod.sandbox.subscribe('initNotifyForm', mod);
						mod.fire('initMobileNotify', {
							formUrl: mod.actionLink.attr('href'),
							title: mod.actionLink.text()
						}, ['initNotifyForm']);
					}
				}
				else if (mod.ctaType === mod.CHECKOUT_URL_TYPES.accessory) {
					mod.quantity = (typeof (mod.quantity) === 'undefined') ? 1 : mod.quantity;

					if (mod.isMobilePage) {
						$.ajax({
							url: this.actionLink.attr('href'),
							type: 'post',
							data: {
								'quantity': mod.quantity
							},
							success: function (data) {
								if (data.Error && data.Error.Code && (data.Error.Code === 'INTERNAL_ERROR')) {
									sdxModal.show({
										title: data.Error.Messages[0],
										text: data.Error.Messages[1] || '',
										displayMode: 'prompt',
										buttons: [{
											title: mod.$ctx.data('close-button-msg'),
											type: 'close',
											primary: false
										}]
									});
								} else {
									location.href = mod.$ctx.data('url-basket');
								}
							}
						});
					}
					else {
						SCS.ecommerceApi.addProductToBasket( // swisscom.ecommerceApi.js
							mod.productId,
							mod.quantity,
							$('html').attr('lang'),
							$('body').attr('data-page-segment'),
							function (data) {
								if (data && SCS.ecommerceApi && SCS.ecommerceApi.showOverlayAfterProductAddedToBasket) {
									SCS.ecommerceApi.showOverlayAfterProductAddedToBasket(data.resultView, data.message, data.status);
								}
								window.scsHeader.metanav.updateShoppingCartItemsIcon();
							},
							function (jqXHR) {
								mod.log(jqXHR);
								$button.qtip({
									content: '<div class="sc-richtext-failure">' +
										(jqXHR.responseText || mod.$ctx.data('orderButtonError')) +
										'</div>',
									style: {
										classes: 'ui-tooltip-ecommerce',
										width: 240
									},
									show: {
										event: 'click',
										effect: function () {
											$(this).fadeIn(1000);
										}
									},
									hide: {
										event: false,
										inactive: 3500,
										effect: function () {
											$(this).fadeOut(1000);
										}
									},
									events: {
										hidden: function (event, api) {
											api.destroy();
										}
									}
								});
								window.scsHeader.metanav.updateShoppingCartItemsIcon();
								$button.qtip('show');
							}
						);
					}
				}
				else {
					if (mod.ctaClickTriggered) {
						event.currentTarget.click();
						mod.ctaClickTriggered = false;
					}
				}
			}
			if (this.hasOverlay || mod.actionLinkDisabled || mod.ctaType === mod.CHECKOUT_URL_TYPES.accessory || mod.ctaType === mod.CHECKOUT_URL_TYPES.notify) {
				event.preventDefault();
			}
		},

		initNotifyForm: function ($form) {
			var mod = this,
				$formContent = $form.find('#notificationForm');

			$form.dialog({
				title: $form.data('title'),
				width: 820,
				classes: { 'ui-dialog': 'scs-notification-dialog' },
				buttons: [{
					text: $formContent.data('button1-text'),
					'class': 'secondary-button',
					click: function () {
						$form.dialog('close');
					}
				}, {
					text: $formContent.data('button2-text'),
					'class': 'primary-button',
					'data-track-action': 'button',
					'data-track-label': 'notify',
					'data-track-location': 'content',
					'data-track-category': $formContent.data('track-family-name'),
					click: function () {
						if (!SCS.portal.validateSimpleForm($form)) {

							$.ajax({
								url: $formContent.data('url'),
								type: 'POST',
								data: $form.serialize(),
								success: function (data) {
									if (data && data.Error && data.Error.Code === 'OK') {
										var title = $form.data('title'),
											$successContent = $form.find('#notificationSuccess').clone().show();

										// Send form data for Adserver
										mod.overlaySuccessTracking($form.serializeArray());

										$form.dialog('close');
										$successContent.dialog({
											title: title,
											buttons: [{
												text: $successContent.data('button1-text'),
												'class': 'primary-button',
												click: function () {
													$successContent.dialog('close');
												}
											}]
										});
									} else {
										$form.dialog('close');
										SCS.portal.showError(data.Error && data.Error.Messages);
									}
								},
								error: function (jqXHR, textStatus, errorThrown) {
									SCS.portal.showError(errorThrown);
								}
							});

						}
					}
				}],
				close: function () {
					$form.detach();
				}
			});
		},

		overlaySuccessTracking: function (formData) {
			var mod = this;

			// Check form data
			if (Object.prototype.toString.call(formData) !== '[object Array]') {
				return false;
			}

			// Vars
			var language = $('html').attr('lang'),
				segment = $('body').data('page-segment'),
				jsonFormData = {},
				marketingCheckbox = false;

			// Create form data in JSON format
			$.each(formData, function () {

				// Ready data for Adserver
				switch (this.name) {
					case 'productId':
						jsonFormData.ProductId = this.value || '';
						break;
					case 'salutation':
						jsonFormData.Salutation = this.value || '';
						break;
					case 'firstName':
						jsonFormData.Firstname = this.value || '';
						break;
					case 'lastName':
						jsonFormData.Lastname = this.value || '';
						break;
					case 'email':
						jsonFormData.Email = this.value || '';
						break;
					case 'confirmMarketing':
						marketingCheckbox = this.value;
						break;
				}
			});

			// Special case for AllowMarketing field
			jsonFormData.AllowMarketing = marketingCheckbox;

			// Send data to ecommerce for parsing
			if (SCS.ecommerceApi) {
				SCS.ecommerceApi.addProductNotification(
					jsonFormData,
					language,
					segment,
					function (data) {
						mod.log('overlaySuccessTracking', data);
					},
					function (jqXHR) {
						mod.log('overlaySuccessTracking', jqXHR);
					}
				);
			}
		},

		/**
		 * Warranty Checkbox Event handler.
		 */
		handleWarranty: function () {
			var mod = this;

			mod.warrantyChecked = mod.warrantyCheckbox.prop('checked');

			mod.updatePlaceholders({
				warrantyChecked: mod.warrantyChecked
			});
		},

		/**
		 * Warranty Checkbox label updater.
		 */
		updateWarrantyLabel: function (element, product) {
			var $label = $(element).siblings('label'),
				$warrantyLabel = $label.find('.warrantyLabel'),
				$warrantyPrice = $label.find('.warrantyPrice');

			if ($warrantyLabel && $warrantyPrice) {
				var labelText = $warrantyLabel.text().replace(/[\{\}0-9]+/, product.getWarrantyPeriod());
				$warrantyLabel.text(labelText);
				$warrantyPrice.text('(' + product.getWarrantyPriceFormatted() + ')');
			}
		},

		/**
		 * Simple Pay Checkbox Event handler.
		 */
		handleSimplePay: function () {
			var mod = this;

			mod.simplePayChecked = mod.simplePayCheckbox.prop('checked');

			if (mod.simplifiedSimplePrice) {
				mod.toggleSimplifiedSimplePrice(mod.simplePayChecked);
			} else {
				mod.toggleSimplePrice(mod.simplePayChecked);
			}

			mod.updatePlaceholders({
				simplePayChecked: mod.simplePayChecked,
				simplePayDuration: (mod.simplePayChecked && SIMPLE_PAY_DURATION_URL_INITIAL_VALUE) || ''
			});

			if (mod.simplePayChecked) {
				mod.addUrlParam(SIMPLE_PAY_URL_KEY, true);
			} else {
				mod.removeUrlParam(SIMPLE_PAY_URL_KEY);
			}
		},

		toggleSimplifiedSimplePrice: function (show) {
			var mod = this;

			mod.title1.toggleClass('is-invisible', show);
			mod.title2.toggleClass('is-invisible', !show);

			mod.priceFirst.toggleClass('is-invisible', show);
			mod.priceSecond.toggleClass('is-invisible', !show);
		},

		toggleSimplePrice: function (show) {
			var mod = this;
			var titleKey = (show ? 'simplepay' : '') + 'title';
			if (mod.title1) {
				mod.title1.text(mod.title1.data(titleKey + '1'));
			}
			if (mod.title2) {
				mod.title2.text(mod.title2.data(titleKey + '2'));
			}
			mod.priceSecond.toggleClass('hidden', show);
			mod.priceFirst.toggleClass('hidden', show);
			mod.simplePayPrices.toggleClass('hidden', !show);
			mod.simplePayInitialPrice.toggleClass('hidden', !show);
		},

		/**
		 * Perform the Tealium tracking when the component became visible
		 */
		trackOnShow: function () {
			var mod = this,
				$tracking = mod.$ctx.find('.tracking');

			if (mod.trackingEnabled($tracking)) {
				mod.log('trackOnShow');
				SCS.portal.datalayer.trackEvent(
					$tracking.data('tracking-action'),
					$tracking.data('tracking-label'),
					$tracking.data('tracking-location'),
					$tracking.data('tracking-category'),
					$tracking.data('tracking-friendlyname')
				);

				SCS.portal.datalayer.trackConversion(
					$tracking.data('tracking-conversioncategory'),
					$tracking.data('tracking-conversiondetail'),
					$tracking.data('tracking-conversionclass')
				);
			}
		},

		/**
		 * Perform the Tealium tracking when the component became visible
		 */
		trackButtonClick: function () {
			var mod = this,
				$tracking = mod.$ctx.find('.tracking');

			if (mod.trackingEnabled($tracking)) {
				mod.log('trackButtonClick');
				// action, label, location, category, linkName, conversionCategory, conversionDetail, conversionClass
				SCS.portal.datalayer.trackEvent(
					$tracking.data('tracking-action') || 'button',
					$tracking.data('tracking-label') || 'order',
					$tracking.data('tracking-location'),
					$tracking.data('tracking-category'),
					$tracking.data('tracking-friendlyname')
				);

				SCS.portal.datalayer.trackConversion(
					$tracking.data('tracking-conversioncategory'),
					$tracking.data('tracking-conversiondetail'),
					$tracking.data('tracking-conversionclass')
				);
			}
		},

		trackingEnabled: function (tracking) {
			return $(tracking).data('tracking-enabled');
		},

		onDialogClosed: function () {
			var mod = this;
			mod.overlayIsOpen = false;
		},

		updateProductId: function (productId) {
			this.currentProductId = productId;
			if (productId) {
				this.$ctx.data('product-id', productId);
				this.$ctx.attr('data-product-id', productId);
				if (this.useAutomaticProductId) {
					this.productId = productId;
				}
			}
		},

		updateFamilyId: function (familyId) {
			if (familyId) {
				this.$ctx.data('family-id', familyId);
				this.$ctx.attr('data-family-id', familyId);
				if (this.useAutomaticFamilyId) {
					this.familyId = familyId;
				}
			}
		},

		/**
		 * Updates the placeholders in the component.
		 *
		 * @method updatePlaceholders
		 * @param {Map/Object} placeholders A map of key value pairs
		 * @return void
		 */
		updatePlaceholders: function (placeholders, replaceAll) {
			var mod = this;

			// Merge with previous placeholders
			if (!replaceAll) {
				placeholders = $.extend({}, mod.previousPlaceholders || {}, placeholders);
				mod.previousPlaceholders = placeholders;
			}

			var element, elementText, attrValue,
				elements = $(mod.PLACEHOLDER_AWARE_ELEMENTS.join(', '), mod.$ctx),
				attributes = mod.PLACEHOLDER_AWARE_ATTRIBUTES;

			elements.each(function () {
				element = $(this);

				// replace in text nodes
				elementText = element.data('placeholder-template');
				if (!elementText) {
					elementText = element.text();
					element.data('placeholder-template', elementText);
				}
				element.text(replacePlaceholders(elementText, placeholders));

				// replace in attributes
				for (var j = 0; j < attributes.length; j += 1) {
					attrValue = element.data('placeholder-template-' + attributes[j]);
					if (!attrValue) {
						attrValue = element.attr(attributes[j]);
						element.data('placeholder-template-' + attributes[j], attrValue);
					}
					if (attrValue) {
						attrValue = replacePlaceholders(attrValue, placeholders);
						element.attr(attributes[j], attrValue);
						if (attributes[j].indexOf('data-') === 0) {
							element.data(attributes[j].substring(5), attrValue);
						}
					}
				}
			});
		},

		/**
		 * Initializes duration radio buttons inside the component.
		 *
		 * Normally radio buttons rely on ScForm module JS, which is not used here,
		 * therefore the handling is re-implemented and adjusted to the specific
		 * needs of this component.
		 *
		 * @method initDurations
		 * @return void
		 */
		initDurations: function () {
			var mod = this,
				radioInputs = $('.custom-radio input:radio', mod.$ctx);
			radioInputs.on('change', function () {
				$(this).parent().find('input:radio').each(function () {
					var label = $(this).parent().find('[for="' + this.id + '"]');
					if (this.checked) {
						label.addClass('checked');
					} else {
						label.removeClass('checked');
					}
				});
			});
			$('.custom-radio label', mod.$ctx).on('click', function () {
				var label = $(this),
					radioInput = label.parent().find('[id="' + label.attr('for') + '"]');
				radioInput.prop('checked', true);
				radioInputs.trigger('change');
				if (mod.productDataChannel) {
					mod.fire('updateStatus', {
						status: {
							subscriptionDuration: radioInput.val() - 0
						},
						origin: SCS.utils.getUniqueIdOfElement(mod.$ctx)
					}, [mod.productDataChannel]);
				}
			});
		},

		getCheckoutUrlType: function (product) {
			var checkoutUrlType = '';

			if (product && product.showNotificationButton()) {
				checkoutUrlType = this.CHECKOUT_URL_TYPES.notify;
			}
			else if (this.CHECKOUT_URL_TYPE !== this.CHECKOUT_URL_TYPES.automatic) {
				checkoutUrlType = this.CHECKOUT_URL_TYPE;
			}
			else if (!!product) {
				if (product.isConfigurationNeeded()) {
					checkoutUrlType = this.CHECKOUT_URL_TYPES.configurableProduct;
				}
				else if (product.isEordersProduct()) {
					checkoutUrlType = this.CHECKOUT_URL_TYPES.eorders;
				}
				else {
					checkoutUrlType = this.CHECKOUT_URL_TYPES.accessory;
				}
			}

			this.ctaType = checkoutUrlType;
			return checkoutUrlType;
		},

		setDuration: function (value) {
			var mod = this;
			$('.custom-radio input:radio[name^="price-order-subscription-duration-"]', mod.$ctx).each(function () {
				var radioButton = $(this);
				if (radioButton.val() === String(value)) {
					radioButton.prop('checked', true);
				}
				radioButton.trigger('change');
			});
		},

		/**
		 * Event handler when the component is shown. Applies only if the component is not used in combination with a
		 * product data hub.
		 *
		 * @method onShow
		 * @return void
		 */
		onShow: function () {
			var mod = this;

			if (!mod.useDynamicPrice) {
				if (mod.trackingTimeout) {
					clearTimeout(mod.trackingTimeout);
					mod.trackingTimeout = null;
				}
				mod.trackingTimeout = setTimeout($.proxy(mod.trackOnShow, mod), mod.TRACKING_TIMEOUT);
			}
		},

		/**
		 * Event handler when the component is hidden. Applies only if the component is not used in combination with a
		 * product data hub.
		 *
		 * @method onHide
		 * @return void
		 */
		onHide: function () {
			var mod = this;

			if (mod.trackingTimeout) {
				clearTimeout(mod.trackingTimeout);
				mod.trackingTimeout = null;
			}
		},

		onGetCheckoutUrl: function (data) {
			// Only send the url if no fixed subscription Id is set.
			// Otherwise it's not the main price order component.
			if (!this.subscriptionId) {
				data.callback({ url: this.actionLink.attr('href') });
			}
		},

		prepareVariantOrderLinks: function () {
			var mod = this;
			var $links = mod.$ctx.find('> .variant-order-links a[href]');
			var links = mod.variantOrderLinks = {};
			$links.each(function () {
				links[this.getAttribute('data-product-detail-id')] = this.href;
			});
		},

		onLoadContractDetails: function () {
			$('[name="filter-subscriptionId"], [name="filter-subscriptionType"]').change();
		}
	});
}(window.Tc.$, window.Tc, window.SCS = window.SCS || {}));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PriceOrderContainer.js
// module id = 165
// module chunks = 0